
import category from '@/mixins/category-data.js'
import seo from '@/mixins/seo.js'
import helpers from '@/mixins/helpers.js'

export default {
  // category ritorna page e seo data
  mixins: [category, seo, helpers],
}
